module.exports = __webpack_public_path__ + "static/media/alcohol-and-drug-activity.7a36e28c.svg";